<template>
  <div>
    <v-form ref="formDadosFinanceiros" lazy-validation v-if="showCpom">
      <v-layout row wrap>
        <v-flex md3 sm12>
          <v-select
            label="Situação patrimonial e financeira"
            class="form-select-box"
            v-model="item.situacao_patrimonial"
            placeholder="Selecionar"
            :rules="[rules.obrigatorio]"
            :items="situacaoEmpresa"
            :item-value="'value'"
            :item-text="'name'"
          ></v-select>
        </v-flex>

        <v-flex md4 sm12>
          <p class="mb-0 pb-0 custom-label">
            Simples Nacional
            <v-tooltip slot="append" bottom>
              <v-icon slot="activator" color="primary" dark class="ml-3 mb-1"
                >info</v-icon
              >
              <span v-html="$strings.simplesNacionalTooltipText"></span>
            </v-tooltip>
          </p>
          <v-radio-group
            row
            class="mb-0 pb-0 pt-3"
            v-model="item.simples_nacional"
            :rules="[(v) => v == true || v == false || 'Campo obrigatório']"
          >
            <v-radio label="Optante" :value="true"></v-radio>
            <v-radio label="Não optante" :value="false"></v-radio>
          </v-radio-group>
        </v-flex>

        <v-flex md4 sm12>
          <p class="mb-0 pb-0 custom-label">
            CPOM Curitiba
            <v-tooltip slot="append" bottom>
              <v-icon slot="activator" color="primary" dark class="ml-3 mb-1"
                >info</v-icon
              >
              <span v-html="$strings.CPOMTooltipText"></span>
            </v-tooltip>
          </p>

          <v-radio-group
            v-model="item.cpom"
            row
            @change="$forceUpdate()"
            class="mb-0 pb-0 pt-3"
            :rules="[(v) => v == true || v == false || 'Campo obrigatório']"
          >
            <v-radio label="Regular" :value="true"></v-radio>
            <v-radio label="Irregular" :value="false"></v-radio>
          </v-radio-group>
        </v-flex>
      </v-layout>
    </v-form>

    <v-flex xs12 v-if="showCpom && !readonly && item.cpom == false">
      <v-alert v-model="alert" dismissible outlined type="warning">
        Evite a retenção do ISS! Informe os dados do responsável para efetuarmos
        seu cadastro no CPOM Curitiba.
      </v-alert>
    </v-flex>

    <contato-component
      class="mt-4"
      v-if="showCpom && item.cpom == false"
      ref="formDadosCpomComponent"
      :representante="item.diretor_financeiro"
      :labelComplementar="'do Diretor Financeiro'"
      :disabledValidation="disabledValidation"
      :readonly="readonly"
      :showCpf="true"
    ></contato-component>

    <v-flex xs12 v-if="showRepFinanceiro">
      <p class="titulo">Contato - Assuntos Financeiros</p>
    </v-flex>

    <contato-component
      class="mt-4"
      v-if="showRepFinanceiro"
      ref="formRepresentanteFinanceiroComponent"
      :representante="item.contato_financeiro"
      :disabledValidation="disabledValidation"
      :readonly="readonly"
      :showEmail="true"
      :showTelefone="true"
    ></contato-component>

    <v-form ref="formDadosBancarios" lazy-validation>
      <v-layout row wrap>
        <v-flex xs12 v-if="showCpom || showRepFinanceiro">
          <p class="titulo">
            Dados Bancários
            <span class="text-muted ml-2">{{ sublabelDadosBancarios }}</span>
          </p>
        </v-flex>

        <v-flex md4 sm12>
          <v-autocomplete
            v-model="item.dados_bancarios.banco"
            :items="bancos"
            :no-data-text="'Nenhum resultado encontrado.'"
            :rules="[rules.obrigatorio]"
            :readonly="readonly"
            item-text="nome"
            item-value="id"
            class="form-select-box"
            label="Banco"
            placeholder="Selecionar"
          ></v-autocomplete>
        </v-flex>

        <v-flex md4 sm12>
          <v-text-field
            class="form-input-box"
            label="Agência"
            v-model="item.dados_bancarios.agencia"
            :rules="[rules.obrigatorio]"
            :readonly="readonly"
            placeholder=" "
          ></v-text-field>
        </v-flex>

        <v-flex md4 sm12>
          <v-text-field
            class="form-input-box"
            label="Conta"
            v-model="item.dados_bancarios.conta"
            :rules="[rules.obrigatorio]"
            :readonly="readonly"
            v-mask="'##################'"
            placeholder=" "
          ></v-text-field>
        </v-flex>
      </v-layout>
    </v-form>
  </div>
</template>

<script lang="js">
export default {
  name: "DadosFinanceirosComponent",
  data() {
    return {
      alert: true,
      rules: {
        obrigatorio: (v) =>
          !!v || this.disabledValidation || "Campo obrigatório",
      },
      situacaoEmpresa: [
        {
          name: "Micro empresa",
          value: "MICRO_EMPRESA",
        },
        {
          name: "Pequena empresa",
          value: "PEQUENA_EMPRESA",
        },
        {
          name: "Média empresa",
          value: "MEDIA_EMPRESA",
        },
        {
          name: "Grande empresa",
          value: "GRANDE_EMPRESA",
        },
      ],
    };
  },
  props: [
    "bancos",
    "item",
    "showCpom",
    "readonly",
    "disabledValidation",
    "showRepresentante",
    "showRepFinanceiro",
    "sublabelDadosBancarios",
  ],
};
</script>

<style lang="scss" scoped>
.titulo {
  font-size: 2vh !important;
}
</style>



// WEBPACK FOOTER //
// ./src/components/DadosFinanceirosComponent.vue